import { Box, Container } from "@mui/material";
import { useEffect, useState } from "react";
import { useConfig } from "../../context/Config/ConfigContext";
import "./FooterInformation.css";

function FooterInformation({ section }) {
	const [sec, setSec] = useState();
	const { config, offset } = useConfig();

	useEffect(() => {
		setSec(document.getElementById(section));
		if (sec) {
			const yPos =
				sec.getBoundingClientRect().top + window.pageYOffset - offset - 20;

			window.scrollTo({ top: yPos, behavior: "smooth" });
		}
	}, [section, sec, offset]);

	return (
		<Container maxWidth="xl">
			<Box className="divFooterInformation">
				{config.footerSections.map((section) => (
					<Box key={section.idFooterSection}>
						<p id={`${section.href}`} className="titleFooterInformation">
							{section.title}
						</p>
						<p className="textFooterInformation">{section.text}</p>
					</Box>
				))}
			</Box>
		</Container>
	);
}

export default FooterInformation;
